module.exports = __webpack_public_path__ + "img/waitPay.0a8889f4.png";